import { render } from "./filtersNegocios.vue?vue&type=template&id=6fb6dfcc&scoped=true"
import script from "./filtersNegocios.vue?vue&type=script&lang=js"
export * from "./filtersNegocios.vue?vue&type=script&lang=js"

import "./filtersNegocios.vue?vue&type=style&index=0&id=6fb6dfcc&lang=scss&scoped=true"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb6dfcc"]])

export default __exports__